module.exports = __webpack_public_path__ + "img/commentaire.4a6338f2.png";